declare var swal: any;
import { Component, OnInit, Input, AfterViewInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SpinnerService } from '../../../../services/spinner.service';
import { ActorService } from '../../../../services/actor.service';
import { AppData } from '../../../../models/appdata';
import { ApiResponseModel } from '../../../../models/api_response_model';
import { NgbModal, ModalDismissReasons, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { HCPService } from '../../../../services/hcp.service';
import * as alertFunctions from '../../../../../shared/data/sweet-alerts';
import { routerTransition } from '../../../../animations/router.animations';
import { NGXToastrService } from '../../../../../../../src/app/shared/services/toastr.service';
import { FDService } from '../../../../../../../src/app/ncs/services/fd.service';
import { GetIVFAdditionalDetailsRequest, IvfExtraDataController } from '../../../../../../../src/app/ncs/models/actor/actor';
import { GenericProcPostRequest } from '../../../../../../../src/app/ncs/models/actor/actor';
import { GenericParams } from '../../../../../../../src/app/ncs/models/actor/actor';
import { FTV } from '../../../../../../../src/app/ncs/models/actor/actor';
import { S_Methods } from '../../../../../../../src/app/ncs/models/actor/actor';
import { NgbIvfAdditionalDetailEditModal } from './ivfadditionaldetailedit.modal';

@Component({
  selector: 'ivf-additional-detail',
  templateUrl: './ivfadditionaldetail.component.html',
  styleUrls: ['./ivfadditionaldetail.component.scss'],
  animations: [routerTransition()]
})

export class IvfAdditionalDetailComponent implements OnInit {

  public isRequesting: boolean = false;
  public ApiResData: ApiResponseModel;

  @Input() CycleCode: number;
  @Input() Title: string;
  @Input() Context: string;

  constructor(private router: Router,
    private route: ActivatedRoute,
    private loaderService: SpinnerService,
    private actorservice: ActorService,
    private hcpservice: HCPService,
    private fdservice: FDService,
    private tosterservice: NGXToastrService,
    private modalService: NgbModal) {

  }

  CurrentGetIVFAdditionalDetailsRequest: IvfExtraDataController[];
  CurrentNotes: IvfExtraDataController;

  LoadAdditionalDetails() {
    var getReq = new GetIVFAdditionalDetailsRequest();
    var gReq: GenericProcPostRequest = new GenericProcPostRequest();
    getReq.ConditionalOperator = 101047;
    //getReq.Branch = AppData.Instance().SelectedBranchCode;
    getReq.CycleCode = this.CycleCode;
    //getReq.Title = this.Title;
    getReq.Context = this.Context;
    getReq.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    var str = JSON.stringify(getReq);
    gReq.ConditionalOperator = 101047;
    gReq.QueryData = str;
    gReq.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.actorservice.Save<GenericProcPostRequest>(
      gReq, S_Methods.GetGenericPost)
      .subscribe((result) => {

        this.ApiResData = result;
        if (!this.ApiResData.hasError) {
          var data: string = this.ApiResData.Result.join("");
          //alert(data);
          this.CurrentGetIVFAdditionalDetailsRequest = JSON.parse(data);
          if (this.CurrentGetIVFAdditionalDetailsRequest.length == 1 && this.CurrentGetIVFAdditionalDetailsRequest[0].DataValue == 'Not Available') {
            this.CurrentNotes = new IvfExtraDataController();// this.CurrentSemanAnalysisController.find(x => x.DataContext == 'SlugishMotile'); //[0];
            this.CurrentNotes.DataContext = this.Context;
            this.CurrentNotes.CycleCode = this.CycleCode;
            //this.CurrentNotes.DataValue = 'Notes';
            this.CurrentNotes.DataType = 'string';
          }
          else {
            if (this.CurrentGetIVFAdditionalDetailsRequest.find(x => x.DataContext == this.Context) != null)
              this.CurrentNotes = this.CurrentGetIVFAdditionalDetailsRequest.find(x => x.DataContext == this.Context);
            else {
              this.CurrentNotes = new IvfExtraDataController();// this.CurrentSemanAnalysisController.find(x => x.DataContext == 'SlugishMotile'); //[0];

              this.CurrentNotes.DataContext = this.Context;

              this.CurrentNotes.CycleCode = this.CycleCode;

              this.CurrentNotes.DataType = 'string';
            }
           }
          //this.CurrentNotes = this.CurrentGetIVFAdditionalDetailsRequest[0].;
          if (this.ApiResData.Result[0].length > 0) {
            //this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');
            this.stopRefreshing();

          }
          else {
            // alertFunctions.AlertParam("Invalid Operation...!");
            this.stopRefreshing();
          }          
        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {
            alert(this.ApiResData.ErrorData);
          }
          else {
            this.stopRefreshing();
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },
        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();
          }
          else {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();
          }
        }
      );
  }

  //CurrentGetIVFAdditionalDetailsRequest: GetIVFAdditionalDetailsRequest;
  //LoadAdditionalDetails() {
  //  var gReq: GenericProcPostRequest = new GenericProcPostRequest();
  //  var getReq: GenericParams = new GenericParams();
  //  getReq.ConditionalOperator = 101047;
  //  getReq.Params = [
  //    new FTV('CycleCode', 'number', this.CycleCode),
  //    new FTV('Title', 'string', this.Title),
  //    new FTV('Context', 'string', this.Context)
  //  ];
  //  getReq.SendApiRequestModel = AppData.Instance().ApiRequestParms;
  //  var str = JSON.stringify(getReq);
  //  gReq.ConditionalOperator = 101047;
  //  gReq.QueryData = str;
  //  gReq.SendApiRequestModel = AppData.Instance().ApiRequestParms;
  //  this.actorservice.Save<GenericProcPostRequest>(
  //    gReq, S_Methods.GetGenericPost)
  //    .subscribe((result) => {

  //      this.ApiResData = result;
  //      if (!this.ApiResData.hasError) {
  //        var data: string = this.ApiResData.Result.join("");
  //        this.CurrentGetIVFAdditionalDetailsRequest = JSON.parse(data)[0];
  //        if (this.ApiResData.Result[0].length > 0) {
  //          this.stopRefreshing();
  //        }
  //        else {
  //          this.stopRefreshing();
  //        }
  //      }
  //      else {
  //        this.stopRefreshing();
  //        if (this.ApiResData.ErrorData != "") {
  //          alert(this.ApiResData.ErrorData);
  //        }
  //        else {
  //          this.stopRefreshing();
  //          alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
  //        }
  //      }

  //    },
  //      (error) => {

  //        if (error == "401 - Unauthorized") {
  //          alertFunctions.AlertParamEr(error);

  //          this.stopRefreshing();
  //        }
  //        else {
  //          alertFunctions.AlertParamEr(error);

  //          this.stopRefreshing();
  //        }
  //      }
  //    );
  //}

  ngOnInit() {
    this.LoadAdditionalDetails();
  }

  EditAdditionalInformation() {
    const modalRef = this.modalService.open(NgbIvfAdditionalDetailEditModal,
      {
        centered: true

      })
    modalRef.componentInstance.CycleCode = this.CycleCode;
    modalRef.componentInstance.Title = this.Title;
    modalRef.componentInstance.Context = this.Context;
    modalRef.componentInstance.Notes = this.CurrentNotes.DataValue;
    modalRef.componentInstance.CurrentNotes = this.CurrentNotes;
    modalRef.result.then(x => { this.LoadAdditionalDetails() })
  }

  private stopRefreshing() {
    this.loaderService.displayLoader(false);
    this.isRequesting = false;
  }
  private StartRefreshing() {
    this.loaderService.displayLoader(true);
    this.isRequesting = true;
  }

}
